import React from 'react';
import API from "../base/API";
import moment from "moment";
import Auth from "../auth/Auth";
import SorTable from "../base/SorTable";
import { translate } from "../base/Translation";

export default class MailLogList extends Auth {

    constructor(props) {
        super(props);

        this.api = new API({
            get_mail_log: "/mail_log/fetch/all?limit_from=:from&limit_max=:to",
        });

        this.state = {
            limit_from: 0,
            limit_to: 99999,
            notifications: [],
            tableData: [],
            tableColumns: [
                { name: "subject", display: translate("Predmet"), sort: true, width: 25 },
                { name: "from", display: translate("Odosielateľ"), sort: true, width: 25 },
                { name: "to", display: translate("Príjemcovia"), sort: true, width: 25 },
                { name: "time", display: translate("Dátum"), sort: true, width: 25 },
            ]
        };
    }

    fetchData() {
        this.api.request({
            cache: true,
            route: "get_mail_log",
            params: { from: this.state.limit_from, to: this.state.limit_to },
            success: (response) => {
                let tableData = this.convertDataForTable(response);
                this.setState({ notifications: response, tableData });
            }
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    convertDataForTable(data) {
        return data.map(function (notification) {
            notification.id = notification.id.replace("@", "_");
            notification.to = notification.to.join(", ");
            notification.from = notification.from.join(", ");
            return notification;
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <SorTable per_page={50} columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="content" title={translate("Mail Log")} right={() => {
                            // Return empty, since when "right" is not used page header is not shown.
                            return "";
                        }} />
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/mail_log/MailLogList.js